'use client'

import Responsive from '@lyra/core/components/Responsive'
import formatUSD from '@lyra/core/utils/formatUSD'
import { InstrumentType } from '@lyra/web/constants/instruments'
import { METADATA_SECONDARY_TITLE } from '@lyra/web/constants/metadata'
import { formatMarketSymbol } from '@lyra/web/utils/markets'
import { useEffect } from 'react'

import { MarketId } from '../../../constants/markets'
import useMarkets from '../../../hooks/useMarkets'
import PerpsPageHelperDesktop from './PerpsPageHelperDesktop'
import PerpsPageHelperMobile from './PerpsPageHelperMobile'

type Props = {
  marketId: MarketId
}

export default function PerpsPageHelper({ marketId }: Props) {
  const market = useMarkets()[marketId]

  useEffect(() => {
    document.title = `${formatUSD(market.spotPrice)} ${formatMarketSymbol(
      marketId,
      InstrumentType.Perps
    )} - ${METADATA_SECONDARY_TITLE}`
  }, [market.spotPrice, marketId])

  return (
    <Responsive
      $desktop={{ height: '100%' }}
      desktop={<PerpsPageHelperDesktop marketId={marketId} />}
      mobile={<PerpsPageHelperMobile marketId={marketId} />}
    />
  )
}
